export const DASHBOARDS_REQUEST = "DASHBOARDS_REQUEST";
export const DASHBOARDS_SUCCESS = "DASHBOARDS_SUCCESS";
export const DASHBOARDS_ERROR = "DASHBOARDS_ERROR";
export const DASHBOARD_SELECT = "DASHBOARD_SELECT";
export const GET_DASHBOARDS = "GET_DASHBOARDS";
